import classNames from 'classnames';
import { observer } from 'mobx-react-lite';
import { FC } from 'react';

import { AllDownloads } from './AllDownloads/AllDownloads';
import { GroupList } from './GroupList/GroupList';
import { MiniAudioPlayer } from './MiniAudioPlayer/MiniAudioPlayer';
import { NewMessageButton } from './NewMessageButton/NewMessageButton';
import { SearchResult } from './SearchResult/SearchResult';
import { useSidebarPanelPresenter } from './SidebarPanel.presenter';
import styles from './SidebarPanel.styles.m.css';
import { SidebarPanelHeader } from './SidebarPanelHeader/SidebarPanelHeader';
import { SidebarPanelNavigation } from './SidebarPanelNavigation/SidebarPanelNavigation';
import { SoftUpdate } from './SoftUpdate/SoftUpdate';
import { SpacePanel } from './SpacePanel/SpacePanel';
import { SpacesList } from './SpacesList/SpacesList';

export const SidebarPanel: FC = observer(() => {
  const presenter = useSidebarPanelPresenter();

  const containerClassNames = classNames(styles.container, {
    [styles.colapsed]: presenter.isCollapsed,
  });

  return (
    <div className={containerClassNames}>
      <SidebarPanelNavigation
        panelMode={presenter.panelMode}
        onPanelModeChange={presenter.onPanelModeChange}
      />

      {!presenter.isCollapsed && (
        <div className={styles.content}>
          {presenter.isShowHeader && (
            <SidebarPanelHeader onSearchChange={presenter.onSearchChange} />
          )}

          <div className={styles.list}>
            {presenter.isShowSearchResults && <SearchResult searchText={presenter.searchText} />}

            {presenter.isShowSpace && <SpacePanel space={presenter.space} />}
            {presenter.isShowSpaces && <SpacesList onShowSpace={presenter.onShowSpace} />}
            {presenter.isShowTalks && <GroupList groups={presenter.allGroups} />}

            {presenter.isShowNewMessageButton && <NewMessageButton />}
          </div>
          <MiniAudioPlayer />
          <AllDownloads />
          <SoftUpdate />
        </div>
      )}
    </div>
  );
});
